import { handleActions } from 'redux-actions'
import update from 'immutability-helper'

const state = {}

export const takeawayWaitingBasket = handleActions({
  SET_TAKEAWAY_WAITING_BASKET: (state, action) => {
    return update(state, {
      $set: action.payload,
    })
  },
}, state)

export default {
  takeawayWaitingBasket,
}



// WEBPACK FOOTER //
// ./src/reducers/components/takeawayWaitingBasket.js